import * as _ from 'lodash';
import initialState from './initialState';

function Circle(state = initialState, action = {}) {
    if (_.isUndefined(action)) {
        return state;
    }

    const {type, payLoad} = action;

    if (type === 'GET_CIRCLES') {
        return {
            circles: payLoad,
        }
    } else if (type === 'GET_CIRCLE') {
        return {
            circle: payLoad,
        }
    }

    return state;
}

export default Circle;
